import { exportArrayToCsv } from '@/lib/csvExport';

const when = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
const sendTo = (o) => (o.send_to_type === 'jobber' ? o.jobber_name : `Any ${o.category}`);

/** Traceability CSV — one row per job order per stage. */
export const exportTrace = (rows) => exportArrayToCsv(
  rows.flatMap((o) => o.stages.map((s) => ({
    jo: o.jo_id, fg: o.fg_name, design: o.design_name, shade: o.shade, route: o.route, status: o.status, send_to: sendTo(o),
    jobbers: o.jobbers.join(' | '), raised: when(o.created_at), due: o.target_date || '', ordered: o.ordered_pcs, sent: o.sent_pcs,
    in_sfg: o.done_pcs, in_progress: o.in_progress_pcs, lost: o.lost_pcs, now: o.current ? `${o.current} (${o.current_pcs} pcs)` : '',
    po: o.po_numbers.join(' | '), supplier: o.suppliers.join(' | '), doc: o.documents.join(' | '),
    stage: s.label, st_done: s.done_pcs, st_wait: s.waiting_pcs, st_stuck: s.stuck ? 'Yes' : '', st_days: s.waiting_pcs ? s.oldest_days : '',
    st_lost: s.lost_pcs || '', st_first: when(s.first_at), st_last: when(s.last_at),
  }))),
  [['jo', 'Job order'], ['fg', 'FG Name'], ['design', 'Design'], ['shade', 'Shade'], ['route', 'Route'], ['status', 'Status'], ['send_to', 'Send to'],
    ['jobbers', 'Jobbers'], ['raised', 'Raised'], ['due', 'Expected delivery'], ['ordered', 'Ordered'], ['sent', 'Sent'], ['in_sfg', 'In SFG'],
    ['in_progress', 'In progress'], ['lost', 'Lost'], ['now', 'Most pieces now'], ['po', 'PO'], ['supplier', 'Supplier'], ['doc', 'Greige document'],
    ['stage', 'Stage'], ['st_done', 'Stage done pcs'], ['st_wait', 'Stage waiting pcs'], ['st_stuck', 'Stuck'], ['st_days', 'Oldest waiting (days)'],
    ['st_lost', 'Rejected pcs'], ['st_first', 'First passed'], ['st_last', 'Last passed']].map(([key, header]) => ({ key, header })),
  'job-order-traceability.csv',
);

export default exportTrace;
